module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_03_FishBob_5R.67efea88.png";